jQuery(document).ready(function($) {
    let franFormName = 'form[name="AfNewFranchiseRequest"]';
    let form_us = $('.elementor-widget-form:eq(0)');
    let form_int = $('.elementor-widget-form:eq(1)');
    if(window.location.href.includes("elementor-preview") == false && $(franFormName).length) {
        form_int.hide();
        hideAll();
        document.getElementById('franchise-form-cancel').onclick = function() {resetForm()};
        $('#franchise-form-cancel').on( 'keydown', function( event ) {
            if ( 13 === event.which ) {
                resetForm();
            }
        });
        // Set OnClick onTab for unHideAll
        $("input[name='form_fields[firstname]'], input[name='form_fields[lastname]'], input[name='form_fields[country]']").on('click focus', function() {
            unHideAll();
        });
        // Check for Success
        setInterval(function() {
            if($('.elementor-message-success').length) {
                hideAll();
                $('.elementor-field-group-firstname').hide();
                $('.elementor-field-group-lastname').hide();                    
                $('#other_country').attr('clicked', false);
                if($('#franchise-form-tab-intl').parent().hasClass('active')) {
                    $('#franchise-form-tab-intl').trigger('click');
                    $( "#outsideUS" ).empty().append( '<div class="elementor-message elementor-message-success-custom" role="alert">The form was sent successfully.</div>' );
                      
                    setTimeout(function(){
                      $('.elementor-message-success-custom').remove();
                    }, 15000);                        
                }
                if (!$( ".lds-ring" ).length) {
                    $( ".elementor-message-success, #outsideUS" ).append( '<br><div class="lds-ring"></div>' );                        
                }                     
            }
        }, 250);
        
        validateInternationalPhoneNumbers('#form-field-phone');
        validateEmailAddress('#form-field-email');
        
        document.getElementById('franchise-form-tab-us').onclick = function() { hideInternationalForm(form_us, form_int); }
        function hideInternationalForm(form_us, form_int) {
            form_int.hide();
            form_us.show();      
            // Remove Success Message
            $('.elementor-message-success').remove();
            
            // Hide Country field and set to US
            $('.elementor-field-group-country').hide();
            $('#form-field-country').val('USA');
            
            // Hide Country of interest
            $('.elementor-field-group-countryofinterest').hide();
            
            // Show First and Last Name fields
            $('.elementor-field-group-firstname').show();
            $('.elementor-field-group-lastname').show();
            
            $("#tabs-int").removeClass("active in");
            $("#tabs-us").addClass("active in");

            // US franchise-form-btn-white and btn-purple
            $('#franchise-form-tab-us').attr('aria-selected', true).parent().addClass('active');

            // INTL franchise-form-btn-purple and btn-white
            $('#franchise-form-tab-intl').attr('aria-selected', false).parent().removeClass('active');  
            
        }
        
        document.getElementById('franchise-form-tab-intl').onclick = function() { hideUSForm(form_us, form_int); }
        function hideUSForm(form_us, form_int) {
            form_us.hide();
            form_int.show();             
            // Remove Success Message
            $('.elementor-message-success').remove();
            
            // Hide Country field and set to US
            $('.elementor-field-group-country').hide();
            $('#form-field-country').val('USA');
            
            if ($("#other_country").attr("clicked") == "false") {
                $("#tabs-us").removeClass("active in");
                $("#tabs-int").addClass("active in");
                $('.elementor-field-group-firstname').hide();
                $('.elementor-field-group-lastname').hide();                
                hideAll();
            }
            // US franchise-form-btn-white and btn-purple
            $('#franchise-form-tab-us').attr('aria-selected', false).parent().removeClass('active');

            // INTL franchise-form-btn-purple and btn-white
            $('#franchise-form-tab-intl').attr('aria-selected', true).parent().addClass('active');  
        }
        
        document.getElementById('other_country').onclick = function() {
            $(this).attr('clicked', true);
            $('#tabs-int').removeClass('active in');
            $('#tabs-us').addClass('active in');
            unHideAll();
            $("html, body").animate({ scrollTop: $("#franchise-form-tab-intl").offset().top }, 1000);
        }
        
        function unHideAll() {
            // Remove Success Message
            $('.elementor-message-success').remove();
            
            // Unhide Everything
            $('.elementor-field-group-firstname').show();
            $('.elementor-field-group-lastname').show();
            $('.elementor-field-group-email').show();
            $('.elementor-field-group-phone').show();
            $('.elementor-field-group-postalcode').show();
            $('.elementor-field-group-starttimeframe').show();
            $('.elementor-field-group-availablecapital').show();
            $('.elementor-field-group-howdidyouhearaboutus').show();
            $('.elementor-field-type-submit').show();
            $('#franchise-form-cancel').show();
            $('#ccpa-notice-heading').show();
            $('#ccpa-notice-text').show();
            $('.elementor-field-group-desiredlocation').show();
            $('.elementor-field-group-countryofinterest').show();
            $('.elementor-field-group-comments').show();
        }
    
        function hideAll() {
            // Hide all fields besides First and Last Name
            $('.elementor-field-group-country').hide();
            $('.elementor-field-group-email').hide();
            $('.elementor-field-group-phone').hide();
            $('.elementor-field-group-postalcode').hide();
            $('.elementor-field-group-desiredlocation').hide();
            $('.elementor-field-group-countryofinterest').hide();
            $('.elementor-field-group-comments').hide(); 
            $('.elementor-field-group-starttimeframe').hide();
            $('.elementor-field-group-availablecapital').hide();
            $('.elementor-field-group-howdidyouhearaboutus').hide();
            $('.elementor-field-type-submit').hide();
            $('.elementor-message-danger').hide();
            $('#franchise-form-cancel').hide();
            $('#ccpa-notice-heading').hide();
            $('#ccpa-notice-text').hide();
            
            // Set Country field to USA
            $('#form-field-country').val('USA');
        }
        
        function resetForm() {
            $('#franchise-form-tab-us').click();
            hideAll();
            $(franFormName).trigger('reset');
            $('#other_country').attr('clicked', false);
            $(franFormName).find('.elementor-error').removeClass('elementor-error');
        }
        
        // Populate the UTM Fields
        populateUTMFields([form_us, form_int]);
        
        // Add maxlength
        let formFields = [];
        formFields[0]  = ['#form-field-firstname', '50'];
        formFields[1]  = ['#form-field-lastname', '50'];
        formFields[2]  = ['#form-field-email', '100'];
        formFields[3]  = ['#form-field-phone', '50'];
        formFields[4]  = ['#form-field-desiredlocation', '100'];
        formFields[6]  = ['#form-field-postalcode', '20'];
        formFields[7]  = ['#form-field-comments', '1000'];
        formFields[8]  = ['#form-field-starttimeframe', '100'];
        formFields[9]  = ['#form-field-availablecapital', '100'];
        formFields[10] = ['#form-field-howdidyouhearaboutus', '100'];
        
        formFields.forEach(function(formField) {
            if (formField[0] != '#form-field-starttimeframe' && formField[0] != '#form-field-availablecapital' && formField[0] != '#form-field-howdidyouhearaboutus') {
                $('form[name=AfNewFranchiseRequest]').find(formField[0]).attr("maxlength", formField[1]);
            }
            if (formField[0] != '#form-field-comments') {
                $('form[name=AfNewFranchiseRequest]').eq(1).find(formField[0]).attr("id", formField[0].substring(1)+'-int');
                $('form[name=AfNewFranchiseRequest]').eq(1).find('label[for="'+formField[0].substring(1)+'"]').attr("for", formField[0].substring(1)+'-int');
            }
        });

    }
});